"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopperContainer = exports.DropdownFooter = exports.DropdownContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getContainerAnimationName = function getContainerAnimationName() {
  return (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 0; transform: translateY(-5px);\n  }\n  to {\n    opacity: 1; transform: translateY(0);\n  }\n"])));
};
var getContainerAnimation = function getContainerAnimation(_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation-name: ", ";\n  animation-duration: ", ";\n  animation-timing-function: ease-in;\n"])), getContainerAnimationName, theme.containerAnimationDuration);
};
var DropdownContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  overflow: hidden;\n\n  border: ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  background: ", ";\n  padding: 0 ", ";\n  border-radius: ", ";\n\n  ", ";\n\n  line-height: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  font-weight: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.containerBorderSize, " solid ").concat(theme.containerBorderColor);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.isClassic ? "0 0 ".concat(theme.containerShadowBlurRadius, " 0 ").concat(theme.containerShadowColor) : "0 1px 2px ".concat(theme.containerShadowColor);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.containerBackgroundColor);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.containerPadding;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.containerBorderRadius;
}, getContainerAnimation, function (_ref7) {
  var theme = _ref7.theme;
  return theme.lineHeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.letterSpacing;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeight;
});
exports.DropdownContainer = DropdownContainer;
var PopperContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  z-index: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.containerZIndex);
});
exports.PopperContainer = PopperContainer;
var DropdownFooter = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  justify-content: flex-end;\n  padding: ", ";\n  border-top: ", ";\n  display: flex;\n  width: 100%;\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.footerPadding;
}, function (_ref14) {
  var theme = _ref14.theme;
  return "".concat(theme.footerBorderSize, " solid ").concat(theme.footerBorderColor);
});
exports.DropdownFooter = DropdownFooter;